module.exports = __webpack_public_path__ + "img/symbol_6.81ac4e4e.png";